module.exports = __webpack_public_path__ + "img/color_02.b2fbcc85.jpg";